import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateProgramComponent } from './create-program.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: CreateProgramComponent,
      },
    ],
    data: {
      allowedRoles: ['pmo', 'admin',]
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateProgramRoutingModule { }
